


function openNav() {
    document.getElementById("mySidenav").style.width = "250px";
}

function closeNav() {
    document.getElementById("mySidenav").style.width = "0";

}  
 

function getPage(){

  var url="https://webilyst.com/projects/shippit-staging/jet/frontend/index.php";
  
  
   $.ajax({
    
	   method: "get",
       url: url,
   		crossDomain: true,
    

     dataType:"json",
       })
             .done(function( json ) {
     $( "<div class=\"content\">").html( json.html ).appendTo( "body" );
  })
     
  

     
  
}
